import { Helmet } from 'react-helmet-async';

interface Props {
  title: string;
}

// The admin panel is never indexed, so this only needs to set the tab
// title — no canonical/OG/hreflang machinery like the public site's Seo.
function Seo({ title }: Props) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
}

export default Seo;
